module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiIAAAAGCAYAAAD+FvUjAAAABGdBTUEAALGPC/xhBQAAAIxJREFUaAXt2DEKgDAMBVAj3kuP1qO1J6sVdOwgtLq8LAkl5MMbuyyKAAECBAgQIPCTQFy5tda9teOaFQECBAgQIEDgA4EcEWW7g47W0z1rBAgQIECAAIHZAqkFlHV2ivsECBAgQIAAgZ7A8yOS20LqLXknQIAAAQIECAwWyIPvOUeAAAECBAgQeCdwAjReCQ07vA3fAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/ellipse_line.png
// module id = 1551
// module chunks = 1